import { render, staticRenderFns } from "./SparStatisticsSummaryTableComponent.vue?vue&type=template&id=3d05d61c&scoped=true&"
import script from "./SparStatisticsSummaryTableComponent.vue?vue&type=script&lang=ts&"
export * from "./SparStatisticsSummaryTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05d61c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
